<script>
  import { createEventDispatcher } from "svelte";
  import Button from "./Button.svelte";
  import closeIcon from "../assets/icons/close.svg";
  import Close from "./svg/Close.svelte";

  export let title = "";

  let overlay;
  const dispatch = createEventDispatcher();
  function close() {
    dispatch("close");
  }
</script>

<div
  bind:this={overlay}
  class="overlay"
  role="none"
  on:touchmove={(ev) => {
    ev.preventDefault();
  }}
  on:click={(ev) => {
    if (ev.target == overlay) {
      ev.preventDefault();
      close();
    }
  }}
>
  <div class="frame">
    <div class="top-bar noselect">
      <div class="title">{title}</div>
      <div
        class="close"
        role="none"
        on:click={(ev) => {
          ev.preventDefault();
          close();
        }}
      >
        <Close></Close>
      </div>
      <!-- <button
        class="close"
        on:click={(ev) => {
          ev.preventDefault();
          close();
        }}
      >
        <img src={closeIcon} alt="Close" />
      </button> -->
    </div>
    <slot></slot>
  </div>
</div>

<svelte:window
  on:keydown={(ev) => {
    if (ev.key === "Escape") {
      ev.preventDefault();
      dispatch("close");
    }
  }}
/>

<style>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: hsla(0, 0%, 50%, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    /* overflow-y: auto; */
    z-index: 1000;
  }
  .frame {
    min-width: 250px;
    min-height: 150px;
    max-width: calc(min(450px, max(calc(min(100vw - 20px, 375px)), 50%)));
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: white;
    box-shadow:
      0px 4px 0px black,
      4px 0px 0px black,
      4px 4px 0px black;
    box-sizing: border-box;
    /* margin-top: calc(46 + 40px); */
    /* margin-bottom: 40px; */
  }
  .close {
    border-left: 1px solid black;
    /* background: none;
    font-size: 18px;
    border: 1px solid black;
    border-radius: 0;
    border: 0;
    border-left: 1px solid black;
     */
    box-sizing: border-box;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    padding: 6px;
    cursor: pointer;
    margin: 0;
  }
  .top-bar {
    box-sizing: border-box;
    border-bottom: 1px solid black;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    padding-left: 10px;
    text-transform: uppercase;
  }

  @media screen and (max-width: 370px), (max-height: 550px) {
    .top-bar {
      height: 46px;
    }
    .close {
      width: 42px;
      height: 100%;
      padding: 5px 10px;
    }
    .frame {
      max-width: initial;
      height: 100%;
      overflow: auto;
    }
  }
</style>
